<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <el-alert
        :closable="false"
        title="温馨提示：资金转移是指收款账户与付款账户之间的金额进行互转，但公户与私户之间不能互转。部分金额由于票据要求无法从收款账户转移到付款账户，只能提现。"
        type="warning" />
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  platformAccountMoneyTurn,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/account/platform/changeMoney',
      formComponents: ['baseForm'],
      editParams: {
        userType: 6,
      },
    };
  },
  methods: {
    editApi: platformAccountMoneyTurn,
    handleSubSucc () {
      this.$alert('金额已增加到对公收款账户。', '转移成功', {
        confirmButtonText: '确定',
      });
      this.close();
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
